import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Features from "../pages/features/page";
import Solutions from "../pages/solutions/page";
import Benefits from "../pages/benefits/page";
import Pricing from "../pages/pricing/page";
import Partners from "../pages/partners/page";
import FAQ from "../pages/faq/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/features",
    element: <Features />,
  },
  {
    path: "/solutions",
    element: <Solutions />,
  },
  {
    path: "/benefits",
    element: <Benefits />,
  },
  {
    path: "/pricing",
    element: <Pricing />,
  },
  {
    path: "/partners",
    element: <Partners />,
  },
  {
    path: "/faq",
    element: <FAQ />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
